import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { RecruiterService } from 'src/app/modules/recruiterpersona/services/recruiter.service';
@Component({
  selector: 'app-excel-download',
  templateUrl: './excel-download.component.html',
  styleUrls: [],
  standalone: false,
})
export class ExcelDownloadComponent implements OnInit {
  @Input() dataSource: any;
  @Input() fileName: string;
  @Input() columnNames = [];
  @Input() eventId: any;

  constructor(
    private datepipe: DatePipe,
    private recruiterService: RecruiterService,
  ) {}

  ngOnInit() {
    console.log('dataSource--', this.dataSource, this.columnNames);
  }

  exportTOExcel() {
    const toExcelDataSource = [];
    if (this.eventId) {
      //  let colsNames = ['unitCode','unitDescription','taxonomyPath','minExperience','maxExperience','target','autoMapped','inviteSent','autoConfirmed','manualConfirmed','totalConfirmed','gap'];
      const columnObjectMapper = {
        'Unit Code': 'unitCode',
        'Unit Description': 'unitDescription',
        Skills: 'taxonomyPath',
        'Min Exp': 'minExperience',
        'Max Exp': 'maxExperience',
        Target: 'target',
        'Auto Mapped': 'autoMapped',
        'Invite Sent': 'inviteSent',
        'Auto Confirmed': 'autoConfirmed',
        'Manual Confirmed': 'manualConfirmed',
        'Total Confirmed': 'totalConfirmed',
        Gap: 'gap',
        'Start Time': 'slotStartTime',
        'No of Slots': 'noOfSlots',
      };
      const colsNames = [
        'Unit Code',
        'Unit Description',
        'Skills',
        'Min Exp',
        'Max Exp',
        'Target',
        'Start Time',
        'No of Slots',
        'Auto Mapped',
        'Invite Sent',
        'Auto Confirmed',
        'Manual Confirmed',
        'Total Confirmed',
        'Gap',
      ];

      // this.dataSource=resp.unitDetailsMap;
      console.log('datasource---', this.dataSource);
      if (this.dataSource) {
        this.dataSource.forEach((object) => {
          const dmyObj = {};
          colsNames.forEach((value) => {
            if (
              value != 'Skills' &&
              value != 'Min Exp' &&
              value != 'Max Exp' &&
              value != 'Start Time' &&
              value != 'No of Slots'
            ) {
              dmyObj[value] = this.convertToString(object[columnObjectMapper[value]]);
            } else {
              dmyObj[value] = null;
            }
          });
          toExcelDataSource.push(dmyObj);
          object.skillDetails.forEach((skVal) => {
            const skillObj = {};
            colsNames.forEach((value) => {
              if (value != 'Unit Code' && value != 'Unit Description') {
                if (value == 'Skills') {
                  let tempSkills = '';
                  skVal[columnObjectMapper[value]].forEach((skillArr) => {
                    if (tempSkills.length > 0) {
                      tempSkills = tempSkills + ',' + skillArr;
                    } else {
                      tempSkills = skillArr;
                    }
                  });
                  skillObj[value] = this.convertToString(tempSkills);
                } else {
                  skillObj[value] = this.convertToString(skVal[columnObjectMapper[value]]);
                }
              } else {
                skillObj[value] = null;
              }
            });
            toExcelDataSource.push(skillObj);
          });
        });

        const a: XLSX.WorkSheet = XLSX.utils.json_to_sheet(toExcelDataSource);
        //const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table.nativeElement);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, a, 'Sheet1');

        /* save to file */
        const fileName = this.fileName ? this.fileName : 'excel-download';
        XLSX.writeFile(wb, fileName + '-' + this.datepipe.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
      }
    } else {
      console.log('column names', this.columnNames);
      //Converting the datasource and exporting as excel file
      //Data might contain extra spaces. We are adding trim function to remove extra spaces
      //console.log("DS--",this.dataSource);

      //console.log("columns",this.columnNames);

      //If we have input of selected columns
      if (this.columnNames && this.columnNames.length > 0) {
        this.dataSource.forEach((object) => {
          const dmyObj = {};
          this.columnNames.forEach((value) => {
            dmyObj[value] = this.convertToString(object[value]);
          });
          toExcelDataSource.push(dmyObj);
        });
      }
      //Else all column to print in excel (when no input column names given)
      else {
        this.dataSource.forEach((object) => {
          const dmyObj = {};

          for (const key in object) {
            dmyObj[key] = this.convertToString(object[key]);
          }
          toExcelDataSource.push(dmyObj);
        });
      }

      const a: XLSX.WorkSheet = XLSX.utils.json_to_sheet(toExcelDataSource);
      //const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table.nativeElement);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, a, 'Sheet1');

      /* save to file */
      const fileName = this.fileName ? this.fileName : 'excel-download';
      XLSX.writeFile(wb, fileName + '-' + this.datepipe.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
    }
  }

  convertToString(data) {
    //console.log(data,"@", Date.parse(data));

    switch (typeof data) {
      case 'boolean':
        return data ? 'True' : 'False';
      case 'number':
        return data.toString();
      case 'string': {
        //Checking if input-data is not a date
        if (!isNaN(Date.parse(data)) && data.includes('00:00:00')) {
          return this.datepipe.transform(data, 'dd/MM/yyyy');
        } else {
          // else input-data is date and converting to dd/MM/yyyy format
          return data.toString();
        }
      }
      default:
        return '';
    }
  }
}
